import { GridItem } from '../../../../models';
import { SearchGetterContext } from '../../search.interfaces';
import { GridItemsReducer } from './grid-items-reducer.interfaces';

export class PromotedsReducer implements GridItemsReducer {
  reduce(gridItems: GridItem[], { state: { promoteds } }: SearchGetterContext): GridItem[] {
    return gridItems.concat(promoteds);
  }
}
